import dataStoreFactory from '~utils/data-store-factory';
import { createContext } from 'react';
import { UploadsPermissionsEmployeesAPI } from '../api/uploads-permissions-employees';
export const UploadsPermissionsEmployeesStore = dataStoreFactory(UploadsPermissionsEmployeesAPI);
export const uploadsPermissionsEmployeesStore = new UploadsPermissionsEmployeesStore();
export const UploadsPermissionsEmployeesStoreContext = createContext(uploadsPermissionsEmployeesStore);
